export default async function waitRefreshToken() {
  if (window.refreshToken) {
    await window.refreshToken;
  }
}
